import styled from "styled-components";

export const ServicesContainer = styled.div``;

export const CardImage = styled.img`
  border-radius: 20px;
  width: 100%;
  background-image: url("${(props) => props.src}");
`;

export const StylingList = styled.ul`
  display: flex;
  list-style: none;
  justify-content: space-around;
  padding: 0;

  @media screen and (max-width: 992px) {
    padding: 5px;
  }
`;

export const StylingListItem = styled.li`
  text-decoration: none;
`;

export const ExtendesServicesContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding-bottom: 20px;

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`;

export const ExtendedServicesColumn = styled.div`
  width: 100%;
`;

export const ExtendesServicesBlock = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

export const ExtendedServicesHeadline = styled.h3``;
